// eslint-disable react/no-array-index-key
import * as React from 'react';
import PropTypes from 'prop-types';
import classname from 'classnames';
import { template } from '@iyunbao/cr-engine';
import { Modal, Button, Toast } from 'zarm';

import UItem from '../item';
import { getFormId } from '../../utils/tools';
import { BaseWidgetProps } from '../../utils/type';
import PdfIframe from '../../pdfIframe';
import PopupBottom from '../../popupBottom';
import LockScroll from '../../lockScroll';

export interface AgreeTermsProps extends BaseWidgetProps {
  value?: any;
  // value: boolean;
  label?: string;
  theme?: 'default' | 'background';
  isShowCloseButton?: boolean;
  isMaskClick?: boolean;
  confirm?: {
    url?: string;
    footer?: Array<{
      label: string;
    }>;
  };
  className?: string;
  validate?: {
    rules: any[];
  };
  mustRead?: {
    isTab?: boolean;
    options: any;
    footer: any;
  };
  justCheckboxEffect?: boolean;
  onOk?: (props: any) => void;
  onCancel?: (props: any) => void;
}

interface AgreeTermsState {
  checked: boolean;
  visible: boolean;
  prevChecked?: boolean;
  visibleRead?: boolean;
  currentPage: number;
  isMustRead?: boolean;
  isClickMustRead: boolean;
  title?: string;
  [propName: string]: any;
}

const getValue = (props: AgreeTermsProps) => {
  let checked = (props.value || false);
  const visible = checked === 'confirm';
  const visibleRead = checked === 'mustRead';

  // 确认层
  if (visible || visibleRead) {
    checked = false;
  }

  return {
    visible,
    visibleRead,
    checked,
    isMustRead: !!(props.mustRead && Object.keys(props.mustRead).length),
  };
};
const cdPrefix = 'countDown';
let timer = 0;

const noRepetitionlistPush = (arr: number[], value: number) => {
  if (arr.indexOf(value) < 0) {
    return [...arr, value];
  }

  return arr;
};

class AgreeTerms extends React.PureComponent<AgreeTermsProps, AgreeTermsState> {
  static propTypes = {
    prefixCls: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
    ]),
    onChange: PropTypes.func,

  };

  static defaultProps = {
    prefixCls: 'crm-agree-terms',
    value: false,
    onChange: () => { },
  };

  state: AgreeTermsState = {
    ...getValue(this.props),
    visibleRead: false,
    currentPage: 0,
    title: '',
    // 之前放在 props.wprops.value 值
    isClickMustRead: false,
    checkeList: [0],          // 强制阅读栈
  };

  static getDerivedStateFromProps(nextProps: AgreeTermsProps, state: AgreeTermsState) {
    if ('value' in nextProps && nextProps.value !== state.prevChecked) {
      return {
        ...getValue(nextProps),
        prevChecked: nextProps.value,
      };
    }

    return null;
  }

  // 倒计时
  countDown = (time: number, key: string, cb: any) => {
    this.setState({ [key]: time });

    timer = setTimeout(() => {
      if (time <= 1) {
        clearTimeout(timer);
        this.setState({ [key]: undefined });
        cb && cb();
      } else {
        this.countDown(time - 1, key, cb);
      }
    }, 1000);
  };

  onChange = (checked: boolean = false, event: any) => {
    const { prefixCls, onChange, ...others } = this.props;
    const { mustRead, _crengine = {} } = this.props;
    const { path, dataBind, form } = _crengine;
    const { isMustRead, currentPage } = this.state;
    const { target } = event;

    // 防止点击A外链，取消勾选 checked=true && tagName='A'
    if (
      !checked
      && target
      && target.tagName === 'A'
    ) {
      return false;
    }

    // 强制阅读，提示层
    if (checked && isMustRead) {
      // 点击A，阻止跳转
      if (target && target.tagName === 'A') {
        event.preventDefault();
      }

      const newState = {
        visibleRead: true,
        title: undefined,
      };

      const { options, footer } = mustRead || {};

      if (Array.isArray(options) && options.length && options[0].label) {
        newState.title = options[currentPage].label;
      }

      // 必读时间倒计时
      if (Array.isArray(footer) && footer.length) {
        footer.map(({ time }, key) => {
          if (time > 0) {
            this.countDown(time, `${cdPrefix}_${key}`, null);
          }

          return key;
        });
      }

      this.setState(newState);
      return false;
    }

    // 重置 form value
    if (form && dataBind) {
      form.setFieldsValue({
        [getFormId(dataBind, path)]: this.inputValue(checked),
      });
    }

    others.value = checked;

    this.setState({
      checked,
    });

    if (onChange) {
      onChange(others);
    }
  };

  // 强制阅读确认
  onMustReadOk = (value: boolean) => {
    const { onOk, prefixCls, onChange, ...others } = this.props;
    const { _crengine = {} } = this.props;
    const { path, dataBind, form } = _crengine;

    others.value = value;

    this.setState({
      visibleRead: false,
      checked: value,
    });

    // 重置 form value
    if (form && dataBind) {
      form.setFieldsValue({
        [getFormId(dataBind, path)]: 1,
      });
    }

    onOk && onOk(others);
  };

  onCancel = () => {
    const { onOk, onCancel, ...others } = this.props;

    others.value = false;

    this.setState({ visible: false });

    onCancel && onCancel(others);
  };

  onOk = () => {
    const { onOk, onCancel, ...others } = this.props;
    const { _crengine = {} } = this.props;
    const { path, dataBind, form } = _crengine;

    others.value = true;

    // 重置 form value
    if (form && dataBind) {
      form.setFieldsValue({
        [getFormId(dataBind, path)]: 1,
      });
    }

    this.setState({
      visible: false,
      checked: true,
    });

    onOk && onOk(others);
  };

  onOkWithoutFooter = (options) => {
    const { currentPage, isClickMustRead, checkeList } = this.state;

    if (Array.isArray(options) && currentPage <= options.length - 2) {
      const newState: any = {
        currentPage: (currentPage + 1),
        checkeList: noRepetitionlistPush(checkeList, currentPage + 1),
      };

      if ('label' in options[currentPage]) {
        newState.title = options[currentPage].label;
      }

      this.setState(newState);
    } else {
      this.onMustReadOk(!isClickMustRead);
    }
  };

  inputValue = (checked: boolean) => {
    return (checked ? 1 : '');
  };

  onClose = () => {
    this.setState({ visibleRead: false });
  };

  // 切换tab
  onChangeTab = (index: number) => {
    const { checkeList } = this.state;
    const { mustRead } = this.props;
    const { footer } = mustRead || {};
    const needControlTabChange = Array.isArray(footer) && footer.filter((item) => item.time).length > 0;

    if (!needControlTabChange) {
      if (checkeList.indexOf(index) >= 0) {
        this.setState({ currentPage: index });
      } else {
        Toast.show('请按顺序逐一阅读并确认');
      }
    } else {
      this.setState({ currentPage: index });
    }
  };

  renderText = (text: string = '') => {
    return template(text);
  };

  // 获取iframe高度
  getIframeHeight = () => {
    // server side
    if (typeof window === 'undefined') {
      return 0;
    }

    const height = (window.innerHeight || document.documentElement.clientHeight) * 0.95 - 100;

    return height;
  };

  renderConfirm() {
    const { visible } = this.state;
    const { prefixCls, label, confirm = {} } = this.props;

    if (!visible) {
      return null;
    }

    return (
      <LockScroll>
        <Modal
          visible={visible}
          maskClosable
          width="80%"
          className={`${prefixCls}-confirm`}
          onCancel={() => this.onCancel()}
        >
          <div className="confirm-title">
            {
              confirm.url ? <img src={confirm.url} alt="" /> : null
            }
          </div>
          <div className="confirm-content">
            {this.renderText(label)}
          </div>
          <div className="confirm-footer">
            {
              Array.isArray(confirm.footer) && confirm.footer.map((item, key) => (
                <Button
                  block
                  shape="round"
                  theme="primary"
                  className="button-confirm"
                  key={`item_${key}`}
                  onClick={() => this.onOk()}
                >
                  {item.label}
                </Button>
              ))
            }
            <i className="button-close" onClick={() => this.onCancel()} />
          </div>
        </Modal>
      </LockScroll>
    );
  }

  renderTitle(mustRead) {
    const { isShowCloseButton } = this.props;
    const { title, currentPage } = this.state;
    const { isTab, options } = mustRead || {};

    if (isTab && Array.isArray(options) && options.length) {
      // 只有条款列表
      if (options.length <= 1) {
        return (
          <div className="agree-terms-popup-title">{options[0].label || '保险条款'}</div>
        );
      }

      const len = options.length;

      const clsTabs = classname('popup-tabs', { 'popup-tabs-close-padding': isShowCloseButton });
      const cls = classname('popup-tabs-item', {
        'popup-tabs-scrollbar': len >= 3,
        'popup-tabs-item-2': len >= 4,
      });

      return (
        <div className={clsTabs}>
          <ul className={cls}>
            {
              options.map(({ label }, key) => (
                <li
                  className={classname({
                    active: (key === currentPage),
                  })}
                  key={`item_${key}`}
                  onClick={() => this.onChangeTab(key)}
                >
                  {label}
                </li>
              ))
            }
          </ul>
        </div>
      );
    }

    return (
      <div className="agree-terms-popup-title">{title || '保险条款'}</div>
    );
  }

  renderMustRead() {
    const { isMustRead, visibleRead, currentPage } = this.state;
    const { prefixCls, mustRead, isShowCloseButton, isMaskClick } = this.props;

    if (!isMustRead) {
      return null;
    }

    const { options, footer } = mustRead || {};

    const labelNode = (item) => {
      if (item && item.value && Array.isArray(item.value)) {
        return item.value.map((vItem, index) => (
          <div
            className={classname('body-item', {
              [`body-item-${vItem.type}`]: vItem.type,
            })}
            key={`item_${currentPage}_${index}`}
          >
            {
              (() => {
                switch (vItem.type) {
                  case 'text':
                    return this.renderText(vItem.label);
                  case 'pdf':
                    return <PdfIframe height={this.getIframeHeight()} href={vItem.href} />;
                  default:
                    return <img src={vItem.href} alt="" />;
                }
              })()
            }
          </div>
        ));
      }

      return null;
    };

    const footerNode = () => {
      // 有footer的，可以时间到确认选中
      if (Array.isArray(footer) && footer.length) {
        return footer.map(({ label, time }, key) => {
          // eslint-disable-next-line react/destructuring-assignment
          const timeCD = this.state[`${cdPrefix}_${key}`];

          return (
            <div
              className="button-item"
              key={`item_${key}`}
            >
              <Button
                block
                shape="round"
                theme="primary"
                className={classname('button-confirm', {
                  'button-confirm-disabled': (time && timeCD > 0),
                })}
                onClick={() => !timeCD && this.onMustReadOk(true)}
              >
                {label}
                {(time && timeCD > 0) ? <span className="time">({timeCD}s后可点击)</span> : null}
              </Button>
            </div>
          );
        });
      }

      return (
        <div className="button-item">
          <Button
            block
            shape="round"
            theme="primary"
            className="button-confirm"
            onClick={() => this.onOkWithoutFooter(options)}
          >
            {(currentPage <= options.length - 2) ? '确认，继续阅读下一条' : '确认，立即投保'}
          </Button>
        </div>
      );
    };

    return (
      <PopupBottom
        visible={visibleRead}
        title={this.renderTitle(mustRead)}
        className={`${prefixCls}-popup`}
        footer={footerNode()}
        isMaskClick={isMaskClick}
        isShowCloseButton={isShowCloseButton}
        onClose={() => this.onClose()}
      >
        {
          (Array.isArray(options) && currentPage <= options.length - 1) ? labelNode(options[currentPage]) : null
        }
      </PopupBottom>
    );
  }

  render() {
    const { checked } = this.state;
    const {
      prefixCls,
      label,
      className,
      theme = 'default',
      confirm,
      mustRead,
      justCheckboxEffect = false,
      _crengine,
      validate,
      ...rest
    } = this.props;
    const cls = classname(prefixCls, className, {
      [`${prefixCls}-checked`]: checked,
    });

    if (validate && validate.rules && validate.rules.length) {
      validate.rules.forEach(rule => {
        // tips 必填校验 指定气泡卡片式的提示样式，
        if (rule.required && rule.message) {
          rule.requiredType = 'popper';
        }
        // 此时需要指定 type 和 dataBind的value一致 https://github.com/yiminghe/async-validator/blob/cc126d62084bfce8b0a84dff652348d5ec72d03f/src/index.ts#L338
        if (!rule.type) {
          rule.type = 'number';
        }
      });
    }

    return (
      <UItem
        {...rest}
        validate={validate}
        itemType="agreeTerms"
        className={`${prefixCls}-${theme}`}
        isLabel={false}
        _crengine={_crengine}
        initialValue={this.inputValue(checked)}
      >
        <div>
          <div
            className={cls}
            onClick={(event) => !justCheckboxEffect && this.onChange(!checked, event)}
          >
            <div className={`${prefixCls}-inner`} onClick={(event) => justCheckboxEffect && this.onChange(!checked, event)} />
            <div className={`${prefixCls}-text`}>
              {this.renderText(label)}
            </div>
          </div>
          {confirm && this.renderConfirm()}
          {mustRead && this.renderMustRead()}
        </div>
      </UItem>
    );
  }
}

export default AgreeTerms;
